const ESC = '\x1B';
const GS = '\x1D';
const FS = '\x1C';
const NUL = '\x00';

// Comandos ESC/POS comunes
const CMD = {
  INIT: ESC + '@',
  BOLD_ON: ESC + 'E' + '\x01',
  BOLD_OFF: ESC + 'E' + '\x00',
  ALIGN_LEFT: ESC + 'a' + '\x00',
  ALIGN_CENTER: ESC + 'a' + '\x01',
  ALIGN_RIGHT: ESC + 'a' + '\x02',
  CUT_PAPER_FULL: GS + 'V' + '\x00',
  LF: '\n',
  SET_CODE_PAGE_PC850: ESC + 't' + '\x02',
  TEXT_SIZE_NORMAL: GS + '!' + '\x00',
  TEXT_SIZE_DOUBLE_WIDTH: GS + '!' + '\x01',
  TEXT_SIZE_DOUBLE_HEIGHT: GS + '!' + '\x10',
  TEXT_SIZE_DOUBLE_WIDTH_HEIGHT: GS + '!' + '\x11',
  TEXT_SIZE_SMALL: GS + '!' + '\x00',
  TEXT_SIZE_CONDENSED: ESC + '\x0F',
  TEXT_SIZE_NORMAL_WIDTH: ESC + '\x14',
  TEXT_SCALE_SMALL: GS + '!' + '\x00',
  TEXT_SCALE_SMALLER: ESC + '\x0F',
  TEXT_SCALE_NORMAL_FONT: ESC + '\x14',
  PRINT_NV_LOGO: (keyCode, mode = 0) => FS + 'p' + String.fromCharCode(keyCode) + String.fromCharCode(mode),
  BARCODE_HEIGHT_DEFAULT: GS + 'h' + '\x50',
  BARCODE_WIDTH_MODULE_DEFAULT: GS + 'w' + '\x02',
  HRI_POSITION_BELOW: GS + 'H' + '\x02',
  HRI_POSITION_NONE: GS + 'H' + '\x00',
  FACTORY_RESET_SPECULATIVE: ESC + 'c' + '1' + '\x00',
};

// --- Funciones de Utilidad ---
function padRight(str, length, char = ' ') {
  return String(str).padEnd(length, char);
}

function padLeft(str, length, char = ' ') {
  return String(str).padStart(length, char);
}

function padCenter(str, length, char = ' ') {
  const padding = Math.max(0, length - String(str).length);
  const leftPad = Math.floor(padding / 2);
  const rightPad = padding - leftPad;
  return char.repeat(leftPad) + str + char.repeat(rightPad);
}

function formatCurrencyESCPOS(value) {
  const num = parseNumber(value);
  return `RD$${num.toLocaleString('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function parseNumber(str) {
  if (str === null || str === undefined || String(str).trim() === '') return 0;
  return Number(String(str).replace(/,/g, ''));
}

function wrapText(text, maxWidth) {
  if (String(text).length <= maxWidth) {
    return [String(text)];
  }

  const words = String(text).split(' ');
  const lines = [];
  let currentLine = "";

  for (const word of words) {
    if (word.length > maxWidth) {
      if (currentLine.length > 0) {
        lines.push(currentLine);
        currentLine = "";
      }
      let tempWord = word;
      while (tempWord.length > maxWidth) {
        lines.push(tempWord.substring(0, maxWidth));
        tempWord = tempWord.substring(maxWidth);
      }
      currentLine = tempWord;
      continue;
    }

    if ((currentLine + (currentLine.length > 0 ? " " : "") + word).length <= maxWidth) {
      currentLine += (currentLine.length > 0 ? " " : "") + word;
    } else {
      if (currentLine.length > 0) {
        lines.push(currentLine);
      }
      currentLine = word;
    }
  }

  if (currentLine.length > 0) {
    lines.push(currentLine);
  }

  return lines.length > 0 ? lines : [String(text).substring(0, maxWidth)];
}

function formatDate(dateString) {
  if (!dateString) return 'No registrada';
  try {
    return new Date(dateString).toLocaleString('es-DO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  } catch (e) {
    return 'Fecha inválida';
  }
}

// =================================================================
// 📄 RECIBO DE REEMBOLSO COMPACTO - 32 CARACTERES (58mm)
// =================================================================
async function generateCompactRefundReceipt32(refundData) {
  const paperWidth = 32;
  const doubleLine = "=".repeat(paperWidth);
  const singleLine = "-".repeat(paperWidth);

  let receipt = CMD.INIT + CMD.SET_CODE_PAGE_PC850;
  
  // === DISCLAMER DE PRÁCTICA ===
  receipt += CMD.ALIGN_CENTER;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += "Esta es una versión de práctica." + CMD.LF;
  receipt += "Los datos son ficticios." + CMD.LF;
  receipt += CMD.LF;
  
  // === ENCABEZADO COMPACTO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON;
  receipt += CMD.PRINT_NV_LOGO(1, 0);
  receipt += CMD.LF;
  receipt += "D'PRINCESS STGO. (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += "Foto Film" + CMD.LF;
  receipt += "Tel.: (809) 708-5336" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // === TÍTULO DEL DOCUMENTO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON;
  receipt += "RECIBO REEMBOLSO (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += CMD.LF;

  // === DATOS BÁSICOS ===
  receipt += CMD.ALIGN_LEFT;
  receipt += `No.: ${String(refundData.refundReceipt?.receiptDocumentNumber || 'N/A')}` + CMD.LF;
  receipt += `Fecha: ${new Date(refundData.refundReceipt?.returnDate || Date.now()).toLocaleDateString('es-DO')}` + CMD.LF;
  
  if (refundData.invoiceData?.clientName) {
    const shortClientName = String(refundData.invoiceData.clientName).substring(0, 20);
    receipt += `Cliente: ${shortClientName}` + CMD.LF;
  }
  
  if (refundData.invoiceData?.invoiceNumber) {
    receipt += `Factura: ${refundData.invoiceData.invoiceNumber}` + CMD.LF;
  }
  
  if (refundData.creditNote?.creditNoteNumber) {
    receipt += `N. Crédito: ${refundData.creditNote.creditNoteNumber}` + CMD.LF;
  }
  
  receipt += singleLine + CMD.LF;

  // === SERVICIOS REEMBOLSADOS SIMPLIFICADOS ===
  receipt += CMD.BOLD_ON + "REEMBOLSOS:" + CMD.BOLD_OFF + CMD.LF;

  if (refundData.refundReceiptDetails && Array.isArray(refundData.refundReceiptDetails)) {
    refundData.refundReceiptDetails.forEach(detail => {
      // Buscar el servicio correspondiente en creditNoteDetails
      const creditDetail = refundData.creditNoteDetails?.find(cd => 
        cd.creditNoteDetailID === detail.creditNoteDetailID
      );
      
      const serviceName = creditDetail?.serviceName || 'Servicio desc.';
      const shortName = String(serviceName).substring(0, 18);
      const amount = parseNumber(detail.amountReturned);
      
      receipt += `${shortName}` + CMD.LF;
      receipt += `${formatCurrencyESCPOS(amount)}` + CMD.LF;
      
      // Mostrar si es cambio de servicio
      if (creditDetail?.newServiceName) {
        receipt += CMD.TEXT_SIZE_CONDENSED;
        const newServiceShort = String(creditDetail.newServiceName).substring(0, 16);
        receipt += `>> ${newServiceShort}` + CMD.LF;
        receipt += CMD.TEXT_SIZE_NORMAL_WIDTH;
      }
    });
  }

  receipt += singleLine + CMD.LF;

  // === TOTALES COMPACTOS ===
  const totalLabelWidth = paperWidth - 12;
  receipt += CMD.BOLD_ON;
  receipt += padRight("TOTAL REEMB.:", totalLabelWidth) + 
    padLeft(formatCurrencyESCPOS(parseNumber(refundData.refundReceipt?.totalAmountReturned)), 12) + CMD.LF;
  receipt += CMD.BOLD_OFF;
  
  if (refundData.refundReceipt?.paymentMethod) {
    receipt += padRight("MÉTODO:", totalLabelWidth) + 
      padLeft(String(refundData.refundReceipt.paymentMethod).toUpperCase(), 12) + CMD.LF;
  }

  // === PIE COMPACTO ===
  receipt += CMD.LF + CMD.ALIGN_CENTER;
  receipt += "¡Gracias por su preferencia!" + CMD.LF;
  receipt += CMD.LF;
  receipt += "Reembolso procesado exitosamente" + CMD.LF;
  receipt += "Conserve este recibo." + CMD.LF;
  receipt += CMD.LF;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += "Datos ficticios para demostración." + CMD.LF;
  receipt += CMD.LF + CMD.LF;
  receipt += CMD.CUT_PAPER_FULL;
  
  return receipt;
}

// =================================================================
// 📄 RECIBO DE REEMBOLSO ESTÁNDAR - 48 CARACTERES (80mm)
// =================================================================
async function generateStandardRefundReceipt48(refundData) {
  const paperWidth = 47;
  const labelChars = 18;
  const valueChars = paperWidth - labelChars - 1;
  
  const doubleLine = "=".repeat(paperWidth);
  const singleLine = "-".repeat(paperWidth);
  const dotLine = ".".repeat(paperWidth);

  let receipt = CMD.INIT + CMD.SET_CODE_PAGE_PC850;

  // === DISCLAMER DE PRÁCTICA ===
  receipt += CMD.ALIGN_CENTER;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += "Esta es una versión de práctica." + CMD.LF;
  receipt += "Los datos son ficticios." + CMD.LF;
  receipt += CMD.LF;
  
  // === ENCABEZADO PROFESIONAL ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON;
  receipt += CMD.PRINT_NV_LOGO(1, 0);
  receipt += CMD.LF;
  receipt += "D'PRINCESS STGO. (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += "Foto Film" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // === TÍTULO DEL DOCUMENTO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON;
  receipt += "RECIBO DE REEMBOLSO (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += CMD.LF;

  // === INFORMACIÓN DEL RECIBO ===
  receipt += CMD.ALIGN_LEFT;
  const currentDateFormatted = new Date().toLocaleString('es-DO', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: true
  });

  receipt += padRight("No. Recibo:", labelChars) + " " + 
    padLeft(String(refundData.refundReceipt?.receiptDocumentNumber || 'N/A'), valueChars) + CMD.LF;
  receipt += padRight("Fecha Reembolso:", labelChars) + " " + 
    padLeft(formatDate(refundData.refundReceipt?.returnDate || Date.now()), valueChars) + CMD.LF;
  receipt += padRight("Fecha Emisión:", labelChars) + " " + 
    padLeft(currentDateFormatted, valueChars) + CMD.LF;
  
  if (refundData.invoiceData?.invoiceNumber) {
    receipt += padRight("Factura No.:", labelChars) + " " + 
      padLeft(String(refundData.invoiceData.invoiceNumber), valueChars) + CMD.LF;
  }
  
  if (refundData.creditNote?.creditNoteNumber) {
    receipt += padRight("Nota Crédito:", labelChars) + " " + 
      padLeft(String(refundData.creditNote.creditNoteNumber), valueChars) + CMD.LF;
  }
  
  if (refundData.invoiceData?.clientName) {
    receipt += padRight("Cliente:", labelChars) + " " + 
      padLeft(String(refundData.invoiceData.clientName).substring(0, valueChars), valueChars) + CMD.LF;
  }
  
  if (refundData.invoiceData?.employeeName) {
    receipt += padRight("Atendido por:", labelChars) + " " + 
      padLeft(String(refundData.invoiceData.employeeName).substring(0, valueChars), valueChars) + CMD.LF;
  }
  
  receipt += singleLine + CMD.LF;

  // === DETALLES DEL REEMBOLSO ===
  receipt += CMD.BOLD_ON + "SERVICIOS REEMBOLSADOS:" + CMD.BOLD_OFF + CMD.LF;
  receipt += padRight("Descripción", 24) + " " + padLeft("Monto", 12) + CMD.LF;
  receipt += dotLine + CMD.LF;

  if (refundData.refundReceiptDetails && Array.isArray(refundData.refundReceiptDetails)) {
    refundData.refundReceiptDetails.forEach(detail => {
      // Buscar el servicio correspondiente en creditNoteDetails
      const creditDetail = refundData.creditNoteDetails?.find(cd => 
        cd.creditNoteDetailID === detail.creditNoteDetailID
      );
      
      const serviceName = creditDetail?.serviceName || 'Servicio desc.';
      const amount = parseNumber(detail.amountReturned);
      
      const nameLines = wrapText(serviceName, 24);
      nameLines.forEach((line, index) => {
        if (index === 0) {
          receipt += padRight(line, 24) + " " + 
            padLeft(formatCurrencyESCPOS(amount), 12) + CMD.LF;
        } else {
          receipt += padRight(line, 24) + " " + " ".repeat(12) + CMD.LF;
        }
      });
      
      // Mostrar concepto si existe
      if (detail.concept && detail.concept !== 'Reembolso por servicio') {
        receipt += CMD.TEXT_SIZE_CONDENSED;
        receipt += `  Motivo: ${detail.concept}` + CMD.LF;
        receipt += CMD.TEXT_SIZE_NORMAL_WIDTH;
      }
      
      // Información adicional si hay cambio de servicio
      if (creditDetail?.newServiceName) {
        receipt += CMD.TEXT_SIZE_CONDENSED;
        receipt += `  >> Cambio por: ${creditDetail.newServiceName}` + CMD.LF;
        receipt += `  >> Precio nuevo: ${formatCurrencyESCPOS(parseNumber(creditDetail.newServicePrice))}` + CMD.LF;
        receipt += `  >> Cantidad nueva: ${parseNumber(creditDetail.newServiceQty)}` + CMD.LF;
        receipt += CMD.TEXT_SIZE_NORMAL_WIDTH;
      }
    });
  }

  receipt += dotLine + CMD.LF;

  // === INFORMACIÓN DE PAGO ===
  receipt += CMD.BOLD_ON + "INFORMACIÓN DEL REEMBOLSO:" + CMD.BOLD_OFF + CMD.LF;
  receipt += padRight("Total Reembolsado:", labelChars + 2) + 
    padLeft(formatCurrencyESCPOS(parseNumber(refundData.refundReceipt?.totalAmountReturned)), valueChars - 2) + CMD.LF;
  receipt += padRight("Método:", labelChars + 2) + 
    padLeft(String(refundData.refundReceipt?.paymentMethod || 'N/D').toUpperCase(), valueChars - 2) + CMD.LF;
  
  if (refundData.refundReceipt?.referenceNumber) {
    receipt += padRight("Referencia:", labelChars + 2) + 
      padLeft(String(refundData.refundReceipt.referenceNumber), valueChars - 2) + CMD.LF;
  }

  if (refundData.refundReceipt?.notes) {
    receipt += singleLine + CMD.LF;
    receipt += CMD.BOLD_ON + "NOTAS:" + CMD.BOLD_OFF + CMD.LF;
    const noteLines = wrapText(refundData.refundReceipt.notes, paperWidth);
    noteLines.forEach(line => {
      receipt += line + CMD.LF;
    });
  }

  // === MOTIVO DEL REEMBOLSO ===
  if (refundData.creditNote?.reason) {
    receipt += singleLine + CMD.LF;
    receipt += CMD.BOLD_ON + "MOTIVO DEL REEMBOLSO:" + CMD.BOLD_OFF + CMD.LF;
    const reasonLines = wrapText(refundData.creditNote.reason, paperWidth);
    reasonLines.forEach(line => {
      receipt += line + CMD.LF;
    });
  }

  receipt += doubleLine + CMD.LF;

  // === PIE DE PÁGINA ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.BOLD_ON + "¡REEMBOLSO PROCESADO EXITOSAMENTE!" + CMD.BOLD_OFF + CMD.LF;
  receipt += CMD.LF;
  receipt += "Este documento es comprobante" + CMD.LF;
  receipt += "del reembolso realizado." + CMD.LF;
  receipt += "Conserve para sus registros." + CMD.LF;
  receipt += CMD.LF;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += "Datos ficticios para demostración." + CMD.LF;
  receipt += CMD.LF + CMD.LF;
  receipt += CMD.CUT_PAPER_FULL;

  return receipt;
}

// =================================================================
// 📄 RECIBO DE REEMBOLSO PREMIUM - 80 CARACTERES
// =================================================================
async function generatePremiumRefundReceipt80(refundData) {
  const paperWidth = 80;
  const labelChars = 25;
  const valueChars = paperWidth - labelChars - 1;
  
  const doubleLine = "=".repeat(paperWidth);
  const singleLine = "-".repeat(paperWidth);
  const dotLine = ".".repeat(paperWidth);

  let receipt = CMD.INIT + CMD.SET_CODE_PAGE_PC850;

  // === DISCLAMER DE PRÁCTICA ===
  receipt += CMD.ALIGN_CENTER;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += "Esta es una versión de práctica." + CMD.LF;
  receipt += "Los datos son ficticios." + CMD.LF;
  receipt += CMD.LF;
  
  // === ENCABEZADO CORPORATIVO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH_HEIGHT + CMD.BOLD_ON;
  receipt += CMD.PRINT_NV_LOGO(1, 0);
  receipt += CMD.LF;
  receipt += "D'PRINCESS SANTIAGO (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += "Foto Films" + CMD.LF;
  receipt += "Teléfono: (809) 708-5336 | WhatsApp: (809) 708-5336" + CMD.LF;
  receipt += "Email: info@dprincess.com" + CMD.LF;
  receipt += "Dirección: Edificio Comercial La Fuente" + CMD.LF;
  receipt += "Av. Yapur Dumit esq., Santiago, República Dominicana" + CMD.LF;
  receipt += doubleLine + CMD.LF;

  // === TÍTULO DEL DOCUMENTO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += CMD.TEXT_SIZE_DOUBLE_WIDTH + CMD.BOLD_ON;
  receipt += "DOCUMENTO DE REEMBOLSO (PRÁCTICA)" + CMD.LF;
  receipt += CMD.BOLD_OFF + CMD.TEXT_SIZE_NORMAL;
  receipt += CMD.LF;

  // === INFORMACIÓN DETALLADA ===
  receipt += CMD.ALIGN_LEFT;
  const currentDateFormattedPremium = new Date().toLocaleString('es-DO', {
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: true
  });

  const colWidth = Math.floor(paperWidth / 2) - 1;

  receipt += padRight(`Recibo No.: ${String(refundData.refundReceipt?.receiptDocumentNumber || 'N/A')}`, colWidth) + " " +
    padLeft(`Fecha: ${formatDate(refundData.refundReceipt?.returnDate || Date.now())}`, colWidth) + CMD.LF;
  receipt += padRight(`Emitido: ${currentDateFormattedPremium}`, colWidth) + " " +
    padLeft(`ID Reembolso: ${refundData.refundReceipt?.refundReceiptID || 'N/A'}`, colWidth) + CMD.LF;
  receipt += singleLine + CMD.LF;

  // === INFORMACIÓN COMPLETA DEL CLIENTE ===
  receipt += CMD.BOLD_ON + "INFORMACIÓN DEL CLIENTE:" + CMD.BOLD_OFF + CMD.LF;
  receipt += `Nombre: ${refundData.invoiceData?.clientName || 'Cliente General'}` + CMD.LF;
  if (refundData.invoiceData?.phoneNumber) {
    receipt += `Teléfono: ${refundData.invoiceData.phoneNumber}` + CMD.LF;
  }
  if (refundData.invoiceData?.clientEmail) {
    receipt += `Email: ${refundData.invoiceData.clientEmail}` + CMD.LF;
  }
  if (refundData.invoiceData?.address) {
    receipt += `Dirección: ${refundData.invoiceData.address}` + CMD.LF;
  }
  receipt += singleLine + CMD.LF;

  // === REFERENCIAS DEL DOCUMENTO ===
  receipt += CMD.BOLD_ON + "REFERENCIAS DEL DOCUMENTO:" + CMD.BOLD_OFF + CMD.LF;
  if (refundData.invoiceData?.invoiceNumber) {
    receipt += `Factura Original: ${refundData.invoiceData.invoiceNumber}` + CMD.LF;
    receipt += `Fecha Factura: ${formatDate(refundData.invoiceData.invoiceDate)}` + CMD.LF;
  }
  if (refundData.creditNote?.creditNoteNumber) {
    receipt += `Nota de Crédito: ${refundData.creditNote.creditNoteNumber}` + CMD.LF;
    receipt += `Fecha N. Crédito: ${formatDate(refundData.creditNote.creditNoteDate)}` + CMD.LF;
    receipt += `Motivo: ${refundData.creditNote.reason || 'No especificado'}` + CMD.LF;
  }
  if (refundData.invoiceData?.employeeName) {
    receipt += `Atendido por: ${refundData.invoiceData.employeeName}` + CMD.LF;
  }
  receipt += singleLine + CMD.LF;

  // === DETALLE COMPLETO DE SERVICIOS REEMBOLSADOS ===
  receipt += CMD.BOLD_ON + "DETALLE COMPLETO DE SERVICIOS REEMBOLSADOS:" + CMD.BOLD_OFF + CMD.LF;
  receipt += padRight("Descripción del Servicio", 45) + " " +
    padCenter("Monto Original", 15) + " " +
    padLeft("Reembolso", 14) + CMD.LF;
  receipt += dotLine + CMD.LF;

  let totalReembolsado = 0;

  if (refundData.refundReceiptDetails && Array.isArray(refundData.refundReceiptDetails)) {
    refundData.refundReceiptDetails.forEach(detail => {
      // Buscar el servicio correspondiente en creditNoteDetails
      const creditDetail = refundData.creditNoteDetails?.find(cd => 
        cd.creditNoteDetailID === detail.creditNoteDetailID
      );
      
      const serviceName = creditDetail?.serviceName || 'Servicio desc.';
      const originalPrice = creditDetail?.servicePrice ? parseNumber(creditDetail.servicePrice) : 0;
      const refundAmount = parseNumber(detail.amountReturned);
      
      const nameLines = wrapText(serviceName + " [REEMBOLSO]", 45);
      
      nameLines.forEach((line, index) => {
        if (index === 0) {
          receipt += padRight(line, 45) + " " +
            padCenter(formatCurrencyESCPOS(originalPrice), 15) + " " +
            padLeft(formatCurrencyESCPOS(refundAmount), 14) + CMD.LF;
        } else {
          receipt += padRight(line, 45) + " " +
            " ".repeat(15) + " " +
            " ".repeat(14) + CMD.LF;
        }
      });
      
      // Mostrar concepto detallado
      if (detail.concept && detail.concept !== 'Reembolso por servicio') {
        receipt += CMD.TEXT_SIZE_CONDENSED;
        receipt += padRight(`  Motivo: ${detail.concept}`, 60) + CMD.LF;
        receipt += CMD.TEXT_SIZE_NORMAL_WIDTH;
      }
      
      // Información adicional si hay cambio de servicio
      if (creditDetail?.newServiceName) {
        receipt += CMD.TEXT_SIZE_CONDENSED;
        receipt += padRight(`  >> Cambio por: ${creditDetail.newServiceName}`, 60) + CMD.LF;
        receipt += padRight(`  >> Nuevo precio: ${formatCurrencyESCPOS(parseNumber(creditDetail.newServicePrice))}`, 60) + CMD.LF;
        receipt += padRight(`  >> Diferencia reembolsada: ${formatCurrencyESCPOS(refundAmount)}`, 60) + CMD.LF;
        receipt += CMD.TEXT_SIZE_NORMAL_WIDTH;
      }
      
      totalReembolsado += refundAmount;
    });
  }

  receipt += dotLine + CMD.LF;

  // === RESUMEN DE CAMBIOS Y MOTIVO ===
  if (refundData.creditNote?.reason) {
    receipt += CMD.BOLD_ON + "MOTIVO DEL REEMBOLSO:" + CMD.BOLD_OFF + CMD.LF;
    const reasonLines = wrapText(refundData.creditNote.reason, paperWidth);
    reasonLines.forEach(line => {
      receipt += line + CMD.LF;
    });
    receipt += singleLine + CMD.LF;
  }

  // === RESUMEN FINANCIERO DETALLADO ===
  const totalsLabelWidthPremium = paperWidth - 16;
  
  receipt += CMD.BOLD_ON;
  receipt += padRight("TOTAL REEMBOLSADO:", totalsLabelWidthPremium) +
    padLeft(formatCurrencyESCPOS(parseNumber(refundData.refundReceipt?.totalAmountReturned)), 16) + CMD.LF;
  receipt += CMD.BOLD_OFF;

  receipt += singleLine + CMD.LF;

  // === INFORMACIÓN DEL REEMBOLSO ===
  receipt += CMD.BOLD_ON + "INFORMACIÓN DEL REEMBOLSO:" + CMD.BOLD_OFF + CMD.LF;
  receipt += padRight("Método de reembolso:", totalsLabelWidthPremium) +
    padLeft(String(refundData.refundReceipt?.paymentMethod || 'N/D').toUpperCase(), 16) + CMD.LF;
  
  if (refundData.refundReceipt?.referenceNumber) {
    receipt += padRight("Número de referencia:", totalsLabelWidthPremium) +
      padLeft(String(refundData.refundReceipt.referenceNumber), 16) + CMD.LF;
  }
  
  receipt += padRight("Fecha de procesamiento:", totalsLabelWidthPremium) +
    padLeft(formatDate(refundData.refundReceipt?.createdAt || Date.now()), 16) + CMD.LF;

  if (refundData.refundReceipt?.notes) {
    receipt += singleLine + CMD.LF;
    receipt += CMD.BOLD_ON + "OBSERVACIONES:" + CMD.BOLD_OFF + CMD.LF;
    const noteLines = wrapText(refundData.refundReceipt.notes, paperWidth);
    noteLines.forEach(line => {
      receipt += line + CMD.LF;
    });
  }

  receipt += doubleLine + CMD.LF;

  // === CÓDIGO DE BARRAS ===
  if (refundData.refundReceipt?.receiptDocumentNumber) {
    const barcodeData = String(refundData.refundReceipt.receiptDocumentNumber).trim();
    if (barcodeData.length > 0 && barcodeData.length < 256) {
      receipt += CMD.ALIGN_CENTER;
      receipt += CMD.BARCODE_HEIGHT_DEFAULT;
      receipt += CMD.BARCODE_WIDTH_MODULE_DEFAULT;
      receipt += CMD.HRI_POSITION_BELOW;

      let code128Command = GS + 'k' + '\x49';
      code128Command += String.fromCharCode(barcodeData.length);
      code128Command += barcodeData;

      receipt += code128Command + CMD.LF + CMD.LF;
    }
  }

  // === PIE DE PÁGINA CORPORATIVO ===
  receipt += CMD.ALIGN_CENTER;
  receipt += doubleLine + CMD.LF;
  receipt += CMD.BOLD_ON + "¡REEMBOLSO PROCESADO EXITOSAMENTE!" + CMD.BOLD_OFF + CMD.LF;
  receipt += CMD.LF;
  receipt += "Este documento constituye su comprobante oficial" + CMD.LF;
  receipt += "del reembolso realizado." + CMD.LF;
  receipt += CMD.LF;
  receipt += "ATENCIÓN AL CLIENTE:" + CMD.LF;
  receipt += "WhatsApp: (809) 708-5336" + CMD.LF;
  receipt += "Email: soporte@dprincess.com" + CMD.LF;
  receipt += "Horario: Lunes a Sábado de 8:00 AM a 8:00 PM" + CMD.LF;
  receipt += CMD.LF;
  receipt += `Documento válido hasta: ${new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)).toLocaleDateString('es-DO')}` + CMD.LF;
  receipt += CMD.LF;
  receipt += "Conserve este documento para futuras referencias." + CMD.LF;
  receipt += CMD.LF;
  receipt += "*** VERSIÓN DE PRÁCTICA ***" + CMD.LF;
  receipt += "Datos ficticios para demostración." + CMD.LF;

  receipt += CMD.LF + CMD.LF + CMD.LF + CMD.CUT_PAPER_FULL;

  return receipt;
}

// =================================================================
// 🎯 FUNCIÓN PRINCIPAL INTELIGENTE PARA REEMBOLSOS
// =================================================================
async function generateThermalRefundReceipt(refundData, paperWidthCharsProvided) {
  if (!refundData || !refundData.refundReceipt) {
    console.error('Datos de reembolso no válidos:', refundData);
    return "";
  }

  // Validar y usar un valor por defecto si paperWidthCharsProvided no es un número válido
  let paperWidthChars = parseInt(paperWidthCharsProvided, 10);
  if (isNaN(paperWidthChars) || paperWidthChars <= 0) {
    console.warn(`Ancho de papel proporcionado ('${paperWidthCharsProvided}') no es válido. Usando 48 por defecto.`);
    paperWidthChars = 48;
  }

  // Ajuste similar al archivo original
  paperWidthChars = paperWidthChars - 10;

  console.log('Generando recibo de reembolso para ancho:', paperWidthChars);
  console.log('Datos del reembolso:', refundData);

  // Determinar automáticamente el formato basado en el ancho
  if (paperWidthChars <= 32) {
    return await generateCompactRefundReceipt32(refundData);
  } else if (paperWidthChars <= 48) {
    return await generateStandardRefundReceipt48(refundData);
  } else {
    return await generatePremiumRefundReceipt80(refundData);
  }
}

// Exportar funciones individuales para uso específico
export {
  generateCompactRefundReceipt32,
  generateStandardRefundReceipt48,
  generatePremiumRefundReceipt80
};

export default generateThermalRefundReceipt;
